var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"btn",style:({
    color: _vm.buttonTextColor,
    background: _vm.buttonBgColor,
  })},[_c('span',{staticClass:"btn__mobile-text",domProps:{"innerHTML":_vm._s(_vm.mobileButtonText)}}),_vm._v(" "),_c('span',{staticClass:"btn__desktop-text",domProps:{"innerHTML":_vm._s(_vm.desktopButtonText)}})])}
var staticRenderFns = []

export { render, staticRenderFns }